<template>
  <div class="detail_appyl">
    <div class="tier">
      <div class="apply_box">
        <applyTable
          :myitem="myitem.detail"
          :myis_apply="myitem.is_apply"
          :TuanFlag="TuanFlag"
          :campInfo="myitem"
          @slideBtn="apply($event)"
        ></applyTable>
      </div>
      <!-- 拼团内容部分拼团横幅 -->
      <div class="Tuan_box" v-if="TuanFlag">
        <!-- 左侧拼团规则部分 -->
        <div class="rule_Box">
          <p class="rule_title">
            拼团规则
            <el-tooltip
              class="item"
              effect="dark"
              content="拼团规则：开团后邀请1人以上参团，人数不够自动退款"
              placement="top"
            >
              <i class="iconfont icon-wenhao"></i>
            </el-tooltip>
          </p>
          <p class="rule_num">9999人正在拼团</p>
        </div>
        <!-- 中间拼团轮播图部分 -->
        <div class="Tuan_swiper_box" ref="swiper_box" :style="swiperStyle">
          <!-- 循环元素 -->
          <div
            @mouseleave="swiperplay()"
            @mouseenter="swiperStop()"
            class="swiper_item"
            v-for="(item, index) in 10"
            :key="index"
          >
            <!-- 头像部分 -->
            <div class="headImag_box">
              <img
                src="https://www.jszg.com/static/platform/pic/img_headpic.png"
                alt=""
              />
            </div>
            <!-- 用户名部分 -->
            <div class="Tuan_name">188****8888</div>
            <!--  右侧拼团内容部分-->
            <div class="right_btn">
              <div class="Tuan_info">
                <p class="Tuan_info_top">还差99人拼成</p>
                <p class="Tuan_info_bottom">
                  剩余<dwonTime endTime="2022.1.24"></dwonTime>
                </p>
              </div>
              <div class="btn">
                <span>去拼团</span>
              </div>
            </div>
            <!-- 侧边 -->
            <div class="bian"></div>
          </div>
        </div>
        <!-- 右侧查看更多部分 -->
        <div class="Tuan_more" @click="dialogTableVisible = true">
          <span>查看更多</span><i class="iconfont icon-jiantou"></i>
        </div>
      </div>
      <!-- 更多拼团的遮罩 -->
      <el-dialog title="可参与的拼团" :visible.sync="dialogTableVisible">
        <div class="Tuan_item">
          <!-- 循环元素 -->
          <div class="Tuanitem" v-for="(item, index) in 10" :key="index">
            <!-- 头像 -->
            <div class="Tuan_Head_box">
              <img
                src="https://www.jszg.com/static/platform/pic/img_headpic.png"
                alt=""
              />
            </div>
            <!-- 信息 -->
            <div class="Tuan_info">
              <div class="Tuan_info_top">
                <span class="Tuan_info_top_name">188****8888</span>
                <span class="Num">还差999人拼成</span>
              </div>
              <div class="Tuan_info_bottom">
                <span>剩余：</span>
                <dwonTime endTime="2022.1.24"></dwonTime>
              </div>
            </div>
            <!-- 右侧按钮 -->
            <div class="Tuan_btn">
              <span>去拼团</span>
            </div>
          </div>
          <div class="Tuan_bottom">
            <span>仅显示10个可参与的拼单</span>
          </div>
        </div>
      </el-dialog>
      <div class="bottom" ref="bottom_box">
        <detailBottom
          :myitem="myitem.lessons"
          :mydesc="myitem.desc"
          :mycamp_id="mycamp_id"
          :myTeacher="myitem.teacher"
          :mykefu="myitem.kefu"
          :is_apply="myitem.is_apply"
          :is_login="myitem.is_login"
          :status="myitem"
          :allMyitem="myitem"
          ref="bottom"
        ></detailBottom>
      </div>
      <div v-if="Mytitle != null" v-title :data-title="Mytitle"></div>
    </div>
    <!-- 2.5版本的白色背景补丁 -->
    <div class="buding" :style="VtwoBuding"></div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import applyTable from "@/components/detail_child/apply_table.vue";
import detailBottom from "@/components/detail_child/detail_bottom.vue";
// 倒计时组件
import dwonTime from "@/components/24hDownTime.vue";
export default {
  components: {
    applyTable,
    detailBottom,
    dwonTime,
  },
  data() {
    return {
      activeName: "second",
      // 当前活动的路由，（同时也是文章ID）
      mycamp_id: "",
      // 元素详情
      myitem: {},
      fullscreenLoading: true, //加载
      // 动态设置pageTitle
      Mytitle: null,
      // 页面加载动画
      loading: this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 1)",
      }),
      // 轮播图函数
      swiper: {
        active: 1, //当前活跃的值
        time: 3000, //自动轮播的间隔
      },
      // 自动轮播事件
      AutoSwiper: null,
      // 更多拼团部分的模态框控制变量
      dialogTableVisible: false,
      // 是否为拼团
      TuanFlag: false,
      // 2.5版本补丁白色背景高度适配
      VtwoBuding: "",
    };
  },
  mounted() {
    this.mycamp_id = this.$route.params.id;
    this.getCampDetail();
    this.swiperplay();
    // 2.5版本版心修改，（只修改详情页）
    this.VtwoPageAuto();

    // 获取登录超时重新登录参数，如果为True则重新进入登录页面
    if (window.sessionStorage.getItem("login")) {
      let nowUrl = window.location.href;
      nowUrl = nowUrl.replace(/#/g, "vue");
      let url = window.location.origin;
      if (sessionStorage.getItem("distrid") != null) {
        window.location.href =
          url +
          "/login?turn_jump_url=" +
          nowUrl +
          "&distrid=" +
          sessionStorage.getItem("distrid");
      } else {
        window.location.href = url + "/login?turn_jump_url=" + nowUrl;
      }

      window.sessionStorage.removeItem("login");
    }
  },
  methods: {
    ...mapMutations(["mydetailMianbao"]),
    handleClick(tab, event) {
      // console.log(tab, event);
      return tab, event;
    },
    MyDayLoock(item) {
      console.log("点击了" + item);
    },
    // 请求打卡详情信息
    getCampDetail() {
      this.$axios
        .get("/getCampDetail", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            camp_id: this.mycamp_id,
          },
        })
        .then((doc) => {
          this.myitem = doc;
          if(doc.detail.allow_refund == 1) {
            this.Mytitle = "打卡特训营-" + doc.detail.name;
          }else {
            this.Mytitle = "新百易考编训练营-" + doc.detail.name;
          }
          this.$forceUpdate();
          this.mydetailMianbao({ detail: doc.detail, study: false });

          let that = this;
          // 请求返回之后关闭页面加载动画
          setTimeout(() => {
            let height = this.$refs.bottom_box.getBoundingClientRect().top - 30;
            that.VtwoBuding = `height:${height}px`;
            that.loading.close();
          }, 500);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 轮播图开始函数
    swiperplay() {
      this.AutoSwiper = setInterval(() => {
        if (this.swiper.active < 4) {
          this.swiper.active++;
        } else {
          this.swiper.active = 1;
        }
      }, this.swiper.time);
    },
    // 轮播图暂停函数
    swiperStop() {
      clearInterval(this.AutoSwiper);
    },
    // 页面滑动
    apply(item) {
      //页面滑动效果
      this.$refs.bottom.activeName = item;
      setTimeout(() => {
        // event为需要跳转的锚点元素ID，如果event为0则返回顶部
        var thisevent = document.querySelector(".bottom");
        // offsetTop为元素到顶部的距离
        var y = thisevent.offsetTop;
        let duration = 500;
        /*y:目标纵坐标,duration:时间(毫秒)*/
        var scrollTop = document.documentElement.scrollTop;

        /*页面当前滚动距离*/
        var distance =
          y - scrollTop; /*结果大于0,说明目标在下方,小于0,说明目标在上方*/
        var scrollCount = duration / 10; /*10毫秒滚动一次,计算滚动次数*/
        var everyDistance =
          distance / scrollCount; /*滚动距离除以滚动次数计算每次滚动距离*/
        for (
          var index = 1;
          index <= scrollCount;
          index++ /*循环设置scrollBy事件,在duration之内,完成滚动效果*/
        )
          setTimeout(function () {
            window.scrollBy(0, everyDistance);
          }, 10 * index);
      }, 0);
    },
    // 2.5版本详情页改版页面修改函数
    VtwoPageAuto() {
      let router = this.$route.path;
      let Reg = /(\/Detail\/apply)/;
      if (router.search(Reg) != -1) {
        this.$(".Detail").css({ width: "1440px" });
      }else{
        this.$(".Detail").css({ width: "" });
      }
    },
  },
  computed: {
    // ...mapState(["token", "agency_id"]),
    agency_id() {
      if (localStorage.getItem("agency_id")) {
        return localStorage.getItem("agency_id");
      } else {
        return 281;
      }
    },
    token() {
      if (localStorage.getItem("token")) {
        return localStorage.getItem("token");
      } else {
        return null;
      }
    },
    // 轮播图计算
    swiperStyle() {
      return `transform: translateY(-${4.4375 * this.swiper.active}rem);`;
    },
  },
  watch: {
    token(val) {
      this.getCampDetail();
      return val;
    },
  },
};
</script>

<style lang="less" scoped>
// 2.5版本改版内容——————————————————————start
.Detail {
  width: 1440px !important;
}

.tier {
  position: relative;
  z-index: 9;
}
.buding {
  background-color: #fff;
  z-index: 0;
  position: absolute;
  left: 0;
  top: 0;
  height: 0px;
  width: 100%;
}
// 2.5版本改版内容——————————————————————end

.detail_appyl {
  width: 100%;
  height: auto;
  .apply_box {
    padding-bottom: 30px;
    width: 100%;
    // height: 26.0625rem;
    height: auto;
    background-color: #fff;
  }

  // 拼团内容部分
  .Tuan_box {
    overflow: hidden;
    margin-top: 0.8125rem;
    width: 100%;
    height: 4.4375rem;
    background: #323232;
    border-radius: 0.1875rem;
    color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    // 拼团左侧拼团规则部分
    .rule_Box {
      width: 9rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background: linear-gradient(90deg, #bf9b61, #edd7b8);
      border-radius: 0.1875rem;

      p {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
      .rule_title {
        font-size: 1.125rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #373737;

        .icon-wenhao {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
        }

        .icon-wenhao::before {
          font-size: 0.9375rem;
          font-weight: 400;
          color: #373737;
        }
      }

      .rule_num {
        font-size: 0.8125rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #6b4b25;
      }
    }

    // 中间轮播图部分
    .Tuan_swiper_box {
      transition: all 0.3s ease;
      padding: 0 4.3125rem;
      flex: 1;
      height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .swiper_item {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 25.9375rem;
        height: 100%;
        // 头像部分
        .headImag_box {
          width: 2.25rem;
          height: 2.25rem;
          overflow: hidden;
          border-radius: 50%;
          img {
            width: 100%;
          }
        }
        // 姓名部分
        .Tuan_name {
          max-width: 5.625rem;
          margin-left: 0.625rem;
          font-size: 0.875rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fbebe9;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .right_btn {
          display: flex;
          flex-direction: row;
          align-items: center;
          // 拼团信息部分
          .Tuan_info {
            margin-left: 2.625rem;
            font-size: 0.75rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            .Tuan_info_top {
              color: #f3f3f3;
            }
            .Tuan_info_bottom {
              color: #ff8a47;
            }
          }
          // 按钮部分
          .btn {
            cursor: pointer;
            margin-left: 0.6875rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width: 4.75rem;
            height: 2.1875rem;
            background: linear-gradient(144deg, #ff5a25, #ff7d3a);
            border-radius: 0.3125rem;
            span {
              font-size: 1rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #ffffff;
            }
          }
        }
        // 边
        .bian {
          height: 2.1875rem;
          flex: 1;
          border-right: 1px solid #fbebe9;
        }
      }
      .swiper_item:nth-child(2n) {
        justify-content: flex-end;
        .bian {
          display: none;
        }
      }
    }
    // 拼团右侧查看更多部分
    .Tuan_more {
      cursor: pointer;
      margin-right: 2.625rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      font-size: 0.875rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #f9f9f9;

      i {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
      .icon-jiantou::before {
        font-size: 0.75rem;
        color: #f9f9f9;
      }
    }
    .Tuan_more:hover {
      color: #ff895b;
      .icon-jiantou::before {
        color: #ff895b;
      }
    }
  }
  // 更多拼团的遮罩部分
  /deep/ .el-dialog {
    width: 20%;
    border-radius: 1.0625rem;
    // head
    .el-dialog__header {
      padding: 1.0625rem;
      text-align: center;
      border-bottom: 1px solid #ebebeb;
      .el-dialog__title {
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #191919;
      }
      .el-dialog__headerbtn {
        top: -0.625rem;
        right: -0.625rem;
        width: 1.75rem;
        height: 1.75rem;
        border-radius: 50%;
        background-color: #e0e0e0;
      }
    }
    // body
    .el-dialog__body {
      padding-top: 0.625rem;
      padding-bottom: 0;
      padding-left: 0;
      padding-right: 0;
      // 拼团弹框部分
      .Tuanitem {
        padding: 0 0.625rem;
        height: 3.4375rem;
        width: 100%;
        border-bottom: 1px solid #ebebeb;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        // 头像
        .Tuan_Head_box {
          width: 2.1875rem;
          height: 2.1875rem;
          overflow: hidden;
          border-radius: 50%;
          img {
            width: 100%;
          }
        }

        // 中间内容部分
        .Tuan_info {
          flex: 1;
          margin: 0 0.9375rem 0 0.4375rem;
          // background-color:red;
          display: flex;
          flex-direction: column;
          .Tuan_info_top {
            display: flex;
            flex-direction: row;
            // justify-content: center;
            align-items: center;
            .Tuan_info_top_name {
              display: inline-block;
              max-width: 6.25rem;
              margin-right: 0.3125rem;
              font-size: 0.75rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #000000;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .Num {
              display: inline-block;
              font-size: 0.75rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #47484a;
            }
          }
          .Tuan_info_bottom {
            font-size: 0.75rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #494b4d;
          }
        }

        // 右侧拼团按钮
        .Tuan_btn {
          cursor: pointer;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          width: 4.125rem;
          height: 1.9375rem;
          background: linear-gradient(90deg, #ee2d25, #dd3234);
          border-radius: 0.3125rem;
          span {
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }

      // 底部文字部分
      .Tuan_bottom {
        height: 2.25rem;
        text-align: center;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        span {
          font-size: 0.75rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #959595;
        }
      }
    }
  }
}
</style>
